import { useTranslation } from "react-i18next";
import React from 'react';
import { Container, Button } from 'reactstrap';
import { Helmet } from 'react-helmet-async';
import AdminLayout from 'Components/Admin/AdminLayout';
import SingleBusiness from 'Components/Admin/SingleBusiness';
export default function Main(props) {
  const {
    t
  } = useTranslation();
  return <AdminLayout>
      <Helmet>
        <title>{t("Admin business - HeresMyInfo.com")}</title>
      </Helmet>
      <Container>
        <h4 className="mb-4" style={{
        fontSize: '1.5rem',
        textTransform: 'none',
        letterSpacing: 'normal',
        fontWeight: 600,
        color: 'white'
      }}>{t("Business details page")}</h4>
        <div className='mb-4 ml-2'>
          <Button color='link' onClick={props.history.goBack}>{'<< '}{t("Back")}</Button>
        </div>
        <SingleBusiness businessId={props.match.params.id} />
      </Container>
    </AdminLayout>;
}